<template>
  <div id='wrap_all'>
    <header id='header'
      className='all_colors header_color light_bg_color  av_header_top av_logo_left av_main_nav_header av_menu_right av_slim av_header_sticky av_header_shrinking av_header_stretch_disabled av_mobile_menu_tablet av_header_searchicon '>
      <div id='header_main' className='container_wrap container_wrap_logo'>
        <div className='container av-logo-container'>
          <div className='inner-container'>
            <span className='logo'><a href='./'><img height='100' width='300'
                  src='../assets/images/young-entrepreneurs.png' alt='Young Entrepreneurs' /></a></span>
            <nav className='main_menu' data-selectname='Select a page'>
              <div class="avia-menu av-main-nav-wrap">
                <ul id="avia-menu" class="menu av-main-nav">
                  <li id="menu-item-41"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-23 current_page_item menu-item-top-level menu-item-top-level-1">
                    <a href='./'><span class="avia-bullet"></span><span class="avia-menu-text">Home</span><span
                        class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                            class="avia-arrow"></span></span></span></a>
                  </li>
                  <li id="menu-item-59"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-mega-parent  menu-item-top-level menu-item-top-level-2">
                    <a href='./'><span class="avia-bullet"></span><span
                        class="avia-menu-text">Register</span><span class="avia-menu-fx"><span
                          class="avia-arrow-wrap"><span class="avia-arrow"></span></span></span></a>
                    <div className='avia_mega_div avia_mega1 three units'>
                      <ul class="sub-menu">
                        <li id="menu-item-61"
                          class="menu-item menu-item-type-post_type menu-item-object-page avia_mega_menu_columns_1 three units avia_mega_menu_columns_last avia_mega_menu_columns_first">
                          <span className='mega_menu_title heading-color av-special-font'><a href='./'>Edit Your
                              Profile</a></span>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li id="menu-item-159"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-top-level menu-item-top-level-3">
                    <a href='./'><span class="avia-bullet"></span><span class="avia-menu-text">Log
                        In</span><span class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                            class="avia-arrow"></span></span></span></a>
                  </li>
                  <li id="menu-item-111"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-mega-parent  menu-item-top-level menu-item-top-level-4">
                    <a href='./'><span class="avia-bullet"></span><span class="avia-menu-text">Entrepreneur
                        Evaluation</span><span class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                            class="avia-arrow"></span></span></span></a>
                    <div className='avia_mega_div avia_mega1 three units'>
                      <ul class="sub-menu">
                        <li id="menu-item-115"
                          class="menu-item menu-item-type-post_type menu-item-object-page avia_mega_menu_columns_1 three units avia_mega_menu_columns_last avia_mega_menu_columns_first">
                          <span className='mega_menu_title heading-color av-special-font'><a href='./'>Entrepreneur
                              Evaluation Test</a></span>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li id="menu-item-267"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-5">
                    <a href='./'><span class="avia-bullet"></span><span class="avia-menu-text">News</span><span
                        class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                            class="avia-arrow"></span></span></span></a>
                  </li>
                  <li id="menu-item-37"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-6">
                    <a href='./'><span class="avia-bullet"></span><span class="avia-menu-text">Contact
                        Us</span><span class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                            class="avia-arrow"></span></span></span></a>
                  </li>
                  <li class="av-burger-menu-main menu-item-avia-special ">
                    <a href='./'>
                      <span class="av-hamburger av-hamburger--spin av-js-hamburger">
                        <span class="av-hamburger-box">
                          <span class="av-hamburger-inner"></span>
                          <strong>Menu</strong>
                        </span>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div className='header_bg'></div>
    </header>

    <div id='main' className='all_colors' data-scroll-offset='88'>
      <div id='after_layer_slider_1' className='main_color av_default_container_wrap container_wrap fullsize'>
        <div className='container'>
          <div className='template-page content  av-content-full alpha units'>
            <div className='post-entry post-entry-type-page post-entry-23'>
              <div className='entry-content-wrapper clearfix'>
                <div
                  className='av-special-heading av-special-heading-h1    avia-builder-el-1  el_after_av_layerslider  el_before_av_hr  avia-builder-el-first   '>
                  <h1 className='av-special-heading-tag '>Welcome to Young
                    Entrepreneurs
                  </h1>
                  <div className='special-heading-border'>
                    <div className='special-heading-inner-border'></div>
                  </div>
                </div>
                <div className='hr hr-default   avia-builder-el-2  el_after_av_heading  el_before_av_two_third '>
                  <span className='hr-inner '><span className='hr-inner-style'></span></span>
                </div>
                <div
                  class="flex_column av_two_third  flex_column_div av-zero-column-padding first  avia-builder-el-3  el_after_av_hr  el_before_av_one_third  ">
                  <section class="av_textblock_section ">
                    <div className='avia_textblock  '>
                      <p><strong>Statements like ‘Entrepreneurs are made not born’ have been given
                          and are in part true, but not wholly accurate. Maths geniuses aren’t
                          made, nor are top scientists otherwise anyone could be taken and
                          made into a top mathematician or scientist. The same can be said for
                          entrepreneurs, successful ones that is. Whilst it’s true that the
                          knowledge required to be acquired by the individuals is imparted
                          from those who have gone before them, the requisite level of
                          intelligence and ability to assimilate information and formulate new
                          ideas and concepts is believed to some degree innate and genetically
                          inherited.</strong>
                      </p>
                      <p>It is therefore important to identify this innate genetic ability at an
                        early stage and begin the nurturing process towards becoming successful
                        entrepreneurs. A genetically gifted athlete who isn’t given the
                        opportunity to train and be coached in the right techniques to make them
                        the best that they can be, would probably never realise the potential
                        that exists within them, a) because it hasn’t been identified and b)
                        because they haven’t been coached how to make the most of their
                        abilities. Top athletes don’t just appear on the world stage without
                        training, they spend many hours, weeks and months refining their skills
                        and even then may not make it to the top level. The same is true of
                        entrepreneurs, they don’t become an immediate success overnight, they
                        learn their trade, hone their skills and surround themselves with the
                        right people and resources.
                      </p>
                      <p>Young Entrepreneurs aims to firstly identify young people who have the
                        innate ability to become entrepreneurs and then nurture them to become
                        successful ones. In order to achieve this we have developed a framework
                        that will enable us to positively identify young entrepreneurs which is
                        the first step on the entrepreneurial journey.
                      </p>
                      <p>Following several years of extensive research in the field of
                        entrepreneurship, we have created a series of surveys and questions that
                        will identify whether or not the person undertaking the examination has
                        the necessary traits and characteristics that make a person
                        entrepreneurial. The scoring algorithm will then determine whether the
                        person has ability to potentially become a successful entrepreneur of
                        the future.
                      </p>
                    </div>
                  </section>
                </div>
                <div
                  class="flex_column av_one_third  flex_column_div av-zero-column-padding   avia-builder-el-5  el_after_av_two_third  avia-builder-el-last  ">
                  <section class="avia_codeblock_section  avia_code_block_0">
                    <div className='avia_codeblock '>
                      <SitePal embed='3432155,600,800,"",1,1,2747479,0,1,1,"PKngrrafcUfGr9BA8x3Ovr6SvUoTJNFk",0,1' />
                    </div>
                  </section>
                  <div className='hr hr-default   avia-builder-el-7  el_after_av_codeblock  el_before_av_video '>
                    <span className='hr-inner '><span className='hr-inner-style'></span></span>
                  </div>
                  <div className='avia-video avia-video-16-9'>
                    <div className='avia-iframe-wrap'>
                      <iframe title='video'
                        src="https://embed.ted.com/talks/cameron_herold_let_s_raise_kids_to_be_entrepreneurs"
                        width="1500" height="844">
                      </iframe>
                    </div>
                  </div>
                </div>
              </div>
              <p class="downloadLink"><a href='/api/examples/vue-responsive/sourcecode.zip' download> Download Vue JS Source Code of this
                  Example </a></p>
            </div>
          </div>
        </div>
      </div>
      <div className='container_wrap footer_color' id='footer'>
        <div className='container'>
          <div className='flex_column av_one_third  first el_before_av_one_third'>
            <section id="nav_menu-2" class="widget clearfix widget_nav_menu">
              <h3 class="widgettitle">Key Pages</h3>
              <div class="menu-main-menu-container">
                <ul id="menu-main-menu" class="menu">
                  <li id="menu-item-41"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-23 current_page_item menu-item-41">
                    <a href='./' aria-current="page">Home</a>
                  </li>
                  <li id="menu-item-59"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-59">
                    <a href='./'>Register</a>
                    <ul class="sub-menu">
                      <li id="menu-item-61"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-61">
                        <a href='./'>Edit Your Profile</a>
                      </li>
                    </ul>
                  </li>
                  <li id="menu-item-159"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-159"><a href='./'>Log
                      In</a></li>
                  <li id="menu-item-111"
                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-111">
                    <a href='./'>Entrepreneur Evaluation</a>
                    <ul class="sub-menu">
                      <li id="menu-item-115"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-115">
                        <a href='./'>Entrepreneur Evaluation Test</a>
                      </li>
                    </ul>
                  </li>
                  <li id="menu-item-267"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-267">
                    <a href='./'>News</a>
                  </li>
                  <li id="menu-item-37"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-37"><a
                      href='./'>Contact Us</a></li>
                </ul>
              </div>
              <span class="seperator extralight-border"></span>
            </section>
            <section id="text-4" class="widget clearfix widget_text">
              <div class="textwidget">
                <p>© Copyright &#8211; Young Entrepreneurs<br />
                  <small>Website designed and built by <a href='./' target="new" rel="noopener">WHD
                      Solutions</a></small>
                </p>
              </div>
              <span class="seperator extralight-border"></span>
            </section>
          </div>
          <div className='flex_column av_one_third  el_after_av_one_third  el_before_av_one_third '>
            <section id="newsbox-2" class="widget clearfix newsbox">
              <h3 class="widgettitle">Young Entrepreneur News</h3>
              <ul class="news-wrap image_size_widget">
                <li class="news-content post-format-standard"><a className='news-link'
                    title='Youth Unemployment &#038; Entrepreneurism' href='./'><span
                      className='news-thumb '></span><strong className='news-headline'>Youth Unemployment
                      &#038; Entrepreneurism<span className='news-time'>23rd February 2018 - 2:58
                        pm</span></strong></a>
                </li>
                <li class="news-content post-format-standard"><a className='news-link' title='Child Entrepreneurs'
                    href='./'><span className='news-thumb '></span><strong className='news-headline'>Child
                      Entrepreneurs<span className='news-time'>23rd
                        February 2018 - 2:53 pm</span></strong></a>
                </li>
              </ul>
              <span class="seperator extralight-border"></span>
            </section>
          </div>
          <div className='flex_column av_one_third  el_after_av_one_third  el_before_av_one_third '>
            <section id="text-3" class="widget clearfix widget_text">
              <h3 class="widgettitle">Interesting LInks</h3>
              <div class="textwidget">
                <p><a href='./' target="_blank" rel="noopener">Cameron Herold &#8211; Raise Kids to be
                    Entrepreneurs </a>
                </p>
                <p><a href='./' target="_blank" rel="noopener">Ken Robson &#8211; Schools Kill
                    Creativity</a>
                </p>
                <p><a href='./' target="_blank" rel="noopener">Julie Lythcott &#8211; Successful Kids
                    Without Over Parenting</a>
                </p>
                <p><a href='./' target="_blank" rel="noopener">Adora Svitak &#8211; What Adults Can Learn
                    From Kids</a>
                </p>
                <p><a href='./' target="_blank" rel="noopener">Sal Kahn &#8211; Teach For Mastery, Not
                    Test Scores</a>
                </p>
                <p><a href='./' target="_blank" rel="noopener">Salaman Kahn &#8211; Let&#8217;s Use Video
                    to Reinvent Education</a>
                </p>
              </div>
              <span class="seperator extralight-border"></span>
            </section>
          </div>
        </div>
      </div>
      <footer className='container_wrap socket_color' id='socket' role="contentinfo">
        <div className='container'>
          <span className='copyright'>© Copyright - Young Entrepreneurs </span>
          <nav className='sub_menu_socket' role="navigation">
            <div class="avia3-menu">
              <ul id="avia3-menu" class="menu">
                <li id="menu-item-109"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-23 current_page_item menu-item-top-level menu-item-top-level-1">
                  <a href='./'><span class="avia-bullet"></span><span class="avia-menu-text">Home</span><span
                      class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                          class="avia-arrow"></span></span></span></a>
                </li>
                <li id="menu-item-103"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-2">
                  <a href='./'><span class="avia-bullet"></span><span
                      class="avia-menu-text">Register</span><span class="avia-menu-fx"><span
                        class="avia-arrow-wrap"><span class="avia-arrow"></span></span></span></a>
                </li>
                <li id="menu-item-430"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-top-level menu-item-top-level-3">
                  <a target="_blank" href='./'><span class="avia-bullet"></span><span
                      class="avia-menu-text">Consent Form</span><span class="avia-menu-fx"><span
                        class="avia-arrow-wrap"><span class="avia-arrow"></span></span></span></a>
                </li>
                <li id="menu-item-432"
                  class="menu-item menu-item-type-custom menu-item-object-custom menu-item-top-level menu-item-top-level-4">
                  <a title="a target=”_blank”" target="_blank" href='./'><span class="avia-bullet"></span><span
                      class="avia-menu-text">Survey
                      Information</span><span class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                          class="avia-arrow"></span></span></span></a>
                </li>
                <li id="menu-item-105"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-top-level menu-item-top-level-5">
                  <a href='./'><span class="avia-bullet"></span><span class="avia-menu-text">Contact
                      Us</span><span class="avia-menu-fx"><span class="avia-arrow-wrap"><span
                          class="avia-arrow"></span></span></span></a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </footer>
    </div>

    <div class="modal fade" id="publishpopup" :style="{ display: ModalDisplay }" role="dialog" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog ">

        <div class="modal-content">
          <div class="modal-header">
            
            <button type="button" class="close" @click="toggleModalDisplay" ><img class="closeBtn" src="../assets/images/cross-image.png"
                alt='closeBtn' /></button>
          </div>
          <div class="modal-body publish-body">
            <div class="publishpop-content">
              <div class="first-content inner-same">

                <img class="characterImg" src="/api/examples/vue-responsive/main-modal.png" alt='characterImg' />
              </div>
            </div>
            <div class="modal-footer save-scene-button">

            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>

import SitePal from 'sitepal-vue'

export default {
  name: 'ThreeDCharacter',
  components: {
    SitePal
  },
  data() {
    return {
      display: false
    };
  }, 
  computed: {
    ModalDisplay() {
      return this.display ? 'none' : 'block'; 
    }
  },
  methods: {
    toggleModalDisplay() {
      this.display = !this.display;
    }
  }
};
</script>

<style scoped>
@import '../assets/css/App.css';
@import '../assets/css/grid.css';
@import '../assets/css/base.css';
@import '../assets/css/layout.css';
@import '../assets/css/shortcodes.css';
@import '../assets/css/enfold.css';


.av-special-heading {
  padding-bottom: 10px;
}

.av-zero-column-padding {
  border-radius: 0;
}

#publishpopup {
  display: block;
}

.close {
  color: #597984;
  border: none;
  background: #fff;
  float: right;
}

.modal-footer {
  border-top: 0px;
}
</style>